import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import styled from 'styled-components';

import { SorareLogo } from '#src/atoms/icons/SorareLogo/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { useResetPassword } from '#src/contexts/wallet/Frame/handlers/index.ts';
import { useWalletContext } from '#src/contexts/wallet/index.ts';

import { ResetPasswordContent } from './ResetPasswordContent/index.tsx';

const Root = styled.div`
  padding: var(--triple-unit);
`;

type Props = {
  open: boolean;
  onClose: () => void;
};
export const ResetPasswordDialog = ({ open, onClose: doOnclose }: Props) => {
  const { promptResetPassword } = useWalletContext();
  const [, setSearchParams] = useSearchParams();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);

  const onSuccess = useCallback(() => setHasSubmitted(true), []);

  useResetPassword({ onSuccess });

  useEffect(() => {
    if (open) promptResetPassword();
  }, [open, promptResetPassword]);

  const onClose = () => {
    setSearchParams({});
    doOnclose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
      title={
        <Horizontal center className="text-center">
          <SorareLogo color="currentColor" />
        </Horizontal>
      }
    >
      <Root>
        <ResetPasswordContent hasSubmitted={hasSubmitted} />
      </Root>
    </Dialog>
  );
};
